import React from "react";
import SectionBeforeTrust from "@containers/LandingPage/libs/MobilePwa/Partials/SectionBeforeTrust";
import { Box } from "@mui/material";
import DigitalisasiPartial from "./AboutPartials/Digitalisasi";
import SuccessStoryPartial from "./AboutPartials/SuccessStory";
import VideoPartial from "./AboutPartials/Video";
import CallUsPartial from "./AboutPartials/CallUs";

const AboutPartial: React.FC = () => {
  const [scrolled, setScrolled] = React.useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 500) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box pt="60px">
      <VideoPartial />
      <DigitalisasiPartial />
      <SectionBeforeTrust />
      <SuccessStoryPartial />
      {scrolled && <CallUsPartial />}
    </Box>
  );
};

export default AboutPartial;
